import seoPages from './seoPages.json';

export const SITE_NAME = seoPages.siteName;
export const SITE_URL = seoPages.siteUrl;
export const SITE_LOCALE = seoPages.locale;
export const DEFAULT_IMAGE = `${seoPages.siteUrl}${seoPages.defaultImage}`;
export const SITE_LOGO = `${seoPages.siteUrl}${seoPages.logo}`;
export const SITE_SAME_AS = seoPages.sameAs;
export const DEFAULT_TITLE = seoPages.pages.home.title;
export const DEFAULT_DESCRIPTION = seoPages.pages.home.description;
export const SEO_KEYWORDS = seoPages.defaultKeywords;

export const PAGE_SEO = seoPages.pages;

/** Absolute URL for a site path or already-absolute URL. */
export function absoluteUrl(pathOrUrl = '/') {
  const value = String(pathOrUrl || '/');
  if (/^https?:\/\//i.test(value)) return value;
  return `${SITE_URL}${value.startsWith('/') ? value : `/${value}`}`;
}
